import React from 'react';
import { withRouter } from 'react-router-dom';
import './index.less'
import { systemConfig,getLoginShopInfo,getTaoteShopName } from '../../utils/http';

class ShowNotice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShow: props.isShow,
        };
        let shop = getLoginShopInfo();
        if(!shop.loginShopId){
            setTimeout(()=>{ 
                shop = getLoginShopInfo();
    
                // if(systemConfig.isShowNoticeImg == true){
                //     if(shop.loginShopPlatformType == 'KuaiShou' 
                //         || shop.loginShopPlatformType == 'XiaoHongShu'
                //         || shop.loginShopPlatformType == 'WeiMeng'
                //         || shop.loginShopPlatformType == 'WxVideo'
                //         || shop.loginShopPlatformType == 'Taobao'
                //         || shop.loginShopPlatformType == 'TouTiao'
                //         || shop.loginShopPlatformType == 'YouZan')
                //     {
                //         this.state.isShow = true;
                //     }
                // }
                // this.setState({ });
            },3000);
        }else{
            // if(systemConfig.isShowNoticeImg == true){
            //     if(shop.loginShopPlatformType == 'KuaiShou' 
            //         || shop.loginShopPlatformType == 'XiaoHongShu'
            //         || shop.loginShopPlatformType == 'WeiMeng'
            //         || shop.loginShopPlatformType == 'WxVideo'
            //         || shop.loginShopPlatformType == 'Taobao'
            //         || shop.loginShopPlatformType == 'TouTiao'
            //         || shop.loginShopPlatformType == 'YouZan')
            //     {
            //         this.state.isShow = true;
            //     }
            // }
            // this.setState({ });
        }
    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        // this.setState({
        //     isShow:props.isShow,
        // })
    }
    closeImg = ()=>{
        systemConfig.isShowNoticeImg = false;
        this.state.isShow = false;
        this.setState({});
    }

    

    targetUrl=(url)=>{
        // this.props.targetUrl("/myAuth")
        if(!url){
            url = 'https://admin.qidian.qq.com/template/blue/mp/menu/qr-code-jump-market.html?linkType=0&env=ol&kfuin=2885720638&fid=31732&key=31b9e94c01e1ca1164f8b497a1d0fc87&cate=1&source=&isLBS=&isCustomEntry=&type=16&ftype=1&_type=wpa&qidian=true';
        }
        window.open(url,'_blank')
    }

    render() {
        return this.state.isShow ? 
            <div className='noticeWarp'>
                <div className='noticeWarp-item'>
                    <img 
                        className='hover' onClick={()=>{ this.targetUrl()}}
                        src='https://www.dgjapp.com/public/images/huodong/puhuo2024-1-16.png'
                    ></img>
                    <i className='iconfont icon-chuyidong hover' style={{fontSize:'18px',position:'absolute',right:'16px',marginBottom:'36px',color:'#fff'}} onClick={()=>{ this.closeImg()}}></i>
                </div>
                
            </div>:null

    }
}

export default ShowNotice;



// WEBPACK FOOTER //
// ./src/components/showNotice/index.jsx